import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/img-animate.css';// 引入懒加载图片样式
import './assets/video-animate.css';// 引入懒加载视频样式

import 'amfe-flexible'

import VueLazyload from 'vue-lazyload'
Vue.config.productionTip = false
Vue.use(ElementUI);

Vue.prototype.$baseRequestURL = "https://opn.homierobot.cn/dev-api";//"http://192.168.3.77:80/dev-api";//

import VueCoreVideoPlayer from 'vue-core-video-player'
//或者
Vue.use(VueCoreVideoPlayer, {
  lang: 'zh-CN'
})
import "vant/lib/index.css";
import {  Col, Row,Icon,Image as VanImage,Popup,Popover ,Button,Overlay,Swipe,SwipeItem   } from "vant"; // 按需引入,优化加载速度
Vue.use(Col);
Vue.use(Row);
Vue.use(Icon);
Vue.use(VanImage);
Vue.use(Popup);
Vue.use(Popover);
Vue.use(Button);
Vue.use(Overlay );
Vue.use(Swipe );
Vue.use(SwipeItem)
// 引入百度地图
import BaiduMap from 'vue-baidu-map';
Vue.use(BaiduMap, {
  ak: "AmDS3u4rR8b3SpmGsj2ie0PxpCGiBVcm"
})



// 修复：简化配置，确保懒加载核心逻辑生效
Vue.use(VueLazyload, {
  preLoad: 1.2, // 降低预加载比例，避免提前加载
  lazyComponent: true,
  // 关键：清空默认loading图，完全靠CSS控制加载动画
  loading: '',
  error: 'https://picsum.photos/400/300?error=1', // 错误占位图
  // 修复：明确监听滚动事件，确保检测到图片进入视口
  listenEvents: ['scroll'],
  // 关键：通过钩子手动标记图片加载状态
  adapter: {
    loaded({ el }) {
      // 图片加载完成，添加loaded类
      el.classList.add('img-loaded');
    },
    error({ el }) {
      // 加载失败，添加error类
      el.classList.add('img-error');
    }
  }
})
// 注册视频懒加载指令（修复版）
Vue.directive('video-lazy', {
  inserted(el, binding) {
    // 1. 初始化：保存视频地址，设置占位图，添加基础类（只加一次）
    el._videoSrc = binding.value
    //el.poster = el.dataset.poster || 'https://picsum.photos/800/450' // 通用占位图
    el.classList.add('video-lazy') // 基础样式类

    // 2. 创建观察者
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 进入可视区域：加载视频 + 触发动画
          el.src = el._videoSrc // 加载视频资源
          el.classList.add('video-lazy-animate') // 添加动画类
          observer.unobserve(el) // 停止观察，避免重复触发
        }
      })
    }, {
      rootMargin: '100px 0px', // 提前加载
      threshold: 0.1
    })

    // 3. 开始观察元素
    observer.observe(el)
    el._observer = observer // 存观察者，用于解绑
  },
  unbind(el) {
    // 解绑时销毁观察者，防止内存泄漏
    if (el._observer) {
      el._observer.unobserve(el)
      el._observer.disconnect()
    }
  }
})
import i18n from './i18n'
Vue.prototype.$lg = function (obj,prop,param) {
  return i18n.t ( "['"+obj+"']"+"['"+prop+"']",param)
}
Vue.prototype.$getLocal = function () {
  return localStorage.getItem('local')
}
Vue.prototype.$getBrStr = function (str,brText,currentLang) {// 英文从指定位置换行
  if(currentLang=='zh'){
    return str
  }
  return str.replace(brText, `${brText}<br>`);
}
new Vue({
  el: '#app',
  router,i18n,
  render: h => h(App),
}).$mount('#app')


